import {
    useGetArchivedPaginatedFinancialBenefitsMutation,
    useGetPaginatedFinancialBenefitsMutation,
    useUpdateFinancialBenefitMutation,
    useCreateFinancialBenefitMutation,
    useToggleArchiveFinancialBenefitMutation
} from '@services/member/list/financial-benefits/financial-benefits.endpoints';
import { FinancialBenefit } from '@services/member/list/financial-benefits/financial-benefits.types';
import { useState, useMemo, useEffect } from 'react';
import { PaginationMetadata } from '@services/providers/cosem.types';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

export const useFinancialBenefitsPageVM = () => {
    const [totalFinancialBenefits, setTotalFinancialBenefits] = useState<number>(0);
    const [isArchived, setIsArchived] = useState<boolean>(false);
    const [needReload, setNeedReload] = useState<boolean>();
    const MySwal = withReactContent(Swal);

    const [
        updateFinancialBenefit,
        {
            isSuccess: isUpdateFinancialBenefitSuccess
        }
    ] = useUpdateFinancialBenefitMutation();

    const [
        createFinancialBenefit,
        {
            isSuccess: isCreateFinancialBenefitSuccess
        }
    ] = useCreateFinancialBenefitMutation();

    const [
        toggleArchiveFinancialBenefit,
        {
            isSuccess: isToggleArchiveFinancialBenefitSuccess
        }
    ] = useToggleArchiveFinancialBenefitMutation();

    const handleArchiveFinancialBenefits = async (lines: FinancialBenefit[], archive: boolean) => {
        MySwal.fire({
            title:
                lines.length === 1
                    ? archive ? 'Êtes-vous sûr de vouloir archiver ce type de prestation financière ?' : 'Êtes-vous sûr de vouloir désarchiver ce type de prestation financière ?'
                    : archive ? 'Êtes-vous sûr de vouloir archiver ces types de prestations financières ?' : 'Êtes-vous sûr de vouloir désarchiver ces types de prestations financières ?',
            icon: 'warning',
            showCancelButton: true,
            iconColor: '#01539D',
            confirmButtonColor: '#01539D',
            confirmButtonText: archive ? 'Archiver' : 'Désarchiver',
            cancelButtonColor: '#FF5F46',
            cancelButtonText: 'Annuler'
        }).then(async (result) => {
            if (result.isConfirmed) {
                lines.forEach((line) => {
                    toggleArchiveFinancialBenefit({ id: line.id, archived: archive });
                });
            }
        });
    };

    useEffect(() => {
        if(isCreateFinancialBenefitSuccess || isUpdateFinancialBenefitSuccess || isToggleArchiveFinancialBenefitSuccess) {
            setNeedReload((prev) => !prev);
        }
    }, [
        isCreateFinancialBenefitSuccess,
        isUpdateFinancialBenefitSuccess,
        isToggleArchiveFinancialBenefitSuccess
    ]);

    const mutationHook = useMemo(() => {
        return isArchived ? useGetArchivedPaginatedFinancialBenefitsMutation : useGetPaginatedFinancialBenefitsMutation;
    }, [isArchived]);

    useEffect(() => {
        setTotalFinancialBenefits(0);
    }, [isArchived]);

    const handleMetadata = (metadata: PaginationMetadata) => {
        if (metadata && metadata.total !== undefined) {
            setTotalFinancialBenefits(metadata.total);
        }
    };

    return {
        mutationHook,
        totalFinancialBenefits,
        setTotalFinancialBenefits,
        isArchived,
        handleMetadata,
        handleArchiveFinancialBenefits,
        needReload,
        MySwal,
        updateFinancialBenefit,
        createFinancialBenefit,
        setIsArchived
    };
};
